<template>
  <div class="loading-wrap">
      <!-- 로고 위치 고정 -->
      <div class="logo-center">
          <div class="ld-logo">spharos</div>
          <div class="ld-txt" v-html="loadingText"></div>
          <!-- <button class="btn-xlg btn-white">취소</button>  -->
      </div>
  </div> 
</template>

<script>
export default {
  name: "loadingText",
  props: {
    loadingText: String,
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


